import { render, staticRenderFns } from "./QuestionBindingsEditor.vue?vue&type=template&id=18b19576&scoped=true&"
import script from "./QuestionBindingsEditor.vue?vue&type=script&lang=js&"
export * from "./QuestionBindingsEditor.vue?vue&type=script&lang=js&"
import style0 from "./QuestionBindingsEditor.vue?vue&type=style&index=0&id=18b19576&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18b19576",
  null
  
)

export default component.exports